export enum LoginProviderEnum {
  FACEBOOK = 'facebook.com',
  GOOGLE = 'google.com',
}
